import { render } from "./Home.vue?vue&type=template&id=7d7dc890&bindings={\"caseStudies\":\"setup-maybe-ref\",\"features\":\"setup-maybe-ref\",\"people\":\"setup-maybe-ref\",\"reviews\":\"setup-maybe-ref\",\"Pagination\":\"setup-maybe-ref\",\"partners\":\"setup-maybe-ref\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script